import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import {
  getDaysLeftUntilPromoExpire,
  getPromoExpireDate,
  isPatientMvp,
} from '../../../../utils/onBoardingUtils'
import {
  ON_BOARDING_COMPLETE_TASK_REWARD,
  TASKS_REQUIRED_TO_MVP,
} from '../../../../consts/OnBoardingConsts'
import Actions from '../../../../actions'
import completedRiskAssessment from '../../../../resources/completedRiskAssessment.png'
import { isMobileWeb } from '../../../../utils/detectMobileWeb'
import config from '../../../../config.json'

import './RiskAssessmentCompletedDialog.css'

const RiskAssessmentCompletedDialog = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const enrollmentDate = userDetails?.hmo_data?.enrollment_date
  const promoPeriodDateExpire = getPromoExpireDate(enrollmentDate)
  const daysLeft = getDaysLeftUntilPromoExpire(promoPeriodDateExpire)

  const isCompleteRiskAssessmentDialogVisible = useSelector(
    state => state.getCare.isCompleteRiskAssessmentDialogVisible
  )
  const isMvp = isPatientMvp(userDetails)

  const sendLinkToMobile = () => {
    if (isMobileWeb()) {
      window.open(config.downloadAppForMobile, '_blank')
    } else {
      dispatch(Actions.createAction(Actions.SHOW_APP_DOWNLOAD_LINK_POP_UP))
    }
    setTimeout(() => {
      dispatch(Actions.createAction(Actions.ENABLE_DOWNLOAD_LINK_BUTTON))
    }, 10000)
    onCancel()
  }

  const onCancel = () => {
    dispatch(Actions.createAction(Actions.RISK_ASSESMENT_BOT_COMPLETED_CLOSED))
  }

  const riskAssessmentCompletedActions = isMvp
    ? [
        <Button
          key="3"
          className="dialog-action trackable"
          data-name="continue"
          type="primary"
          onClick={() => {
            onCancel()
          }}
        >
          {$t('common.continue')}
        </Button>,
      ]
    : [
        <Button
          key="1"
          className="dialog-action trackable"
          data-name="download-app"
          type="primary"
          onClick={() => {
            sendLinkToMobile()
          }}
        >
          {$t('riskAssessmentCompletedDialog.downloadApp')}
        </Button>,
        <Button
          key="2"
          className="dialog-action trackable"
          data-name="continue"
          type="secondary"
          onClick={() => {
            onCancel()
          }}
        >
          {$t('common.continue')}
        </Button>,
      ]

  return (
    <Dialog
      title={
        isMvp
          ? $t('riskAssessmentCompletedDialog.titleMVP')
          : $t('riskAssessmentCompletedDialog.titleNotMVP')
      }
      isVisible={isCompleteRiskAssessmentDialogVisible}
      footerActions={riskAssessmentCompletedActions}
      onCancel={onCancel}
      image={completedRiskAssessment}
      className="risk-assessment-complete-dialog"
    >
      <div className="subtitle">
        {isMvp
          ? $t('riskAssessmentCompletedDialog.subtitleMVP', {
              reward: ON_BOARDING_COMPLETE_TASK_REWARD,
              totalReward:
                ON_BOARDING_COMPLETE_TASK_REWARD * TASKS_REQUIRED_TO_MVP,
            })
          : $t('riskAssessmentCompletedDialog.subtitleNotMVP', {
              days: daysLeft,
              reward: ON_BOARDING_COMPLETE_TASK_REWARD,
              totalReward:
                ON_BOARDING_COMPLETE_TASK_REWARD * TASKS_REQUIRED_TO_MVP,
            })}
      </div>
    </Dialog>
  )
}

export default RiskAssessmentCompletedDialog
